var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3115 10.2148C18.4359 10.2295 18.5492 10.2954 18.623 10.3965L20.4199 12.8555L19.6924 13.3857L18.5566 11.832C18.2008 15.6402 14.9978 18.6217 11.0967 18.6221C8.21318 18.6221 5.71031 16.9927 4.45703 14.6074L5.25391 14.1895C6.35788 16.2902 8.56076 17.7217 11.0967 17.7217C14.5231 17.7214 17.3375 15.1077 17.6592 11.7656L16.2783 12.9453L15.9854 12.6045L15.6934 12.2617L17.9668 10.3193C18.062 10.238 18.1872 10.2004 18.3115 10.2148ZM10.9033 3.61426C13.7869 3.61426 16.2897 5.24356 17.543 7.62891L16.7461 8.04688C15.6421 5.94602 13.4393 4.51465 10.9033 4.51465C7.45983 4.51498 4.63413 7.15446 4.33594 10.5205L5.97461 9.53906L6.4375 10.3105L3.77441 11.9092C3.56142 12.037 3.28421 11.9677 3.15625 11.7549L1.55762 9.09082L2.33008 8.62793L3.43652 10.4727C3.76003 6.63167 6.97878 3.61459 10.9033 3.61426Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/Sync.9bbbc701119be3b8812c197f31babb44.svg";
export { ForwardRef as ReactComponent };